export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_CRITERE = 'SET_CRITERE';
export const SET_SOLDE = 'SET_SOLDE';
export const SET_DATE_SOLDE = 'SET_DATE_SOLDE';
export const SET_LASTPAYLOAD = 'SET_LASTPAYLOAD';
